module.exports = __webpack_public_path__ + "static/img/gd-10.6dea2bec.jpg";